import { Voter } from '../voter';

export class UnlimitedPlanVoter extends Voter {
    supports(request) {
        return request.role === 'unlimited' && request.resource !== 'page-templates';
    }

    vote() {
        return true;
    }
}
